import { useState, useContext } from 'react';

import TrophysContext from '../../context/trophys/trophysContext';
import AlertContext from '../../context/alert/alertContext';

import { REQOP_BY_NUM, REQOP_BY_VRM, REQOP_BY_VIN } from '../../context/types';

const SearchTrophy = () => {
  const trophysContext = useContext(TrophysContext);
  const alertContext = useContext(AlertContext);

  const [textSearch, setTextSearch] = useState('');
  const [textReqOp, setTextReqOp] = useState(REQOP_BY_NUM);
  const [textType, setTextType] = useState('number');
  const [textPlaceholder, setTextPlaceholder] = useState('Number...');

  const doSearchByNum = () => {
    // Trim leading/trailing whitespace and leading zeros
    let valStr = textSearch.trim();
    valStr = valStr.replace(/^0+/, '');

    // Check for a valid number
    const regExp = new RegExp('^\\d+$');
    if (valStr.length > 3 || !regExp.test(valStr)) {
      alertContext.setAlert('Please enter a valid number!', 'danger');
      return;
    }

    // Check the integer value to ensure it is in the correct range
    const valInt = parseInt(valStr);
    if (valInt > 0 && valInt < 501) {
      trophysContext.searchTrophy(REQOP_BY_NUM, valStr);
    } else {
      alertContext.setAlert(
        'Please enter a number in the range of 1-500.',
        'danger',
      );
    }
  };

  const doSearchByVRM = () => {
    // Trim and remove whitespace, convert to uppercase
    let valStr = textSearch.trim();
    valStr = valStr.replace(/\s/g, '').toUpperCase();

    // Check for a valid registration - https://gist.github.com/danielrbradley/7567269
    const regExp = new RegExp(
      '(^[A-Z]{2}[0-9]{2}s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)',
    );
    if (!regExp.test(valStr)) {
      alertContext.setAlert('Please enter a valid registration!', 'danger');
    } else {
      trophysContext.searchTrophy(REQOP_BY_VRM, valStr);
    }
  };

  const doSearchByVIN = () => {
    // Trim and remove whitespace, convert to uppercase
    let valStr = textSearch.trim();
    valStr = valStr.replace(/\s/g, '').toUpperCase();

    // Check for a valid VIN - Unable to derive a suitable regex for UK VIN at present...
    const regExp = new RegExp('[VF1CB220F34]{11}[0-9]{6}');
    if (valStr.length !== 17 || !regExp.test(valStr)) {
      alertContext.setAlert('Please enter a valid VIN!', 'danger');
    } else {
      trophysContext.searchTrophy(REQOP_BY_VIN, valStr);
    }
  };

  const onSubmit = (evt) => {
    evt.preventDefault();

    // Determine the search type to be carried out
    if (textReqOp === REQOP_BY_NUM) {
      // Search by unique number
      doSearchByNum();
    } else if (textReqOp === REQOP_BY_VRM) {
      // Search by registration plate
      doSearchByVRM();
    } else if (textReqOp === REQOP_BY_VIN) {
      // Search by VIN
      doSearchByVIN();
    } else {
      // Something went wrong...
      alertContext.setAlert(
        'Sorry, an error has occurred. Please try again.',
        'danger',
      );
    }
  };

  // const onClearResults = (evt) => {
  //   evt.preventDefault();
  //   setTextSearch('');
  //   trophysContext.clearTrophy();
  // };

  const onChangeSearch = (evt) => {
    setTextSearch(evt.target.value);
  };

  const onClickSearchType = (evt) => {
    setTextSearch('');
    setTextReqOp(evt.target.dataset.searchtype);

    switch (evt.target.dataset.searchtype) {
      case REQOP_BY_NUM:
      default:
        setTextType('number');
        setTextPlaceholder('Number...');
        break;
      case REQOP_BY_VRM:
        setTextType('text');
        setTextPlaceholder('Registration...');
        break;
      case REQOP_BY_VIN:
        setTextType('text');
        setTextPlaceholder('VIN...');
        break;
    }
  };

  return (
    <div>
      {/* New */}

      <div className="mb-4">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div className="form-wrapper card bg-body-tertiary shadow p-4 d-md-block">
              <h2 className="mb-3 text-white">Find Trophy</h2>

              <p className="mb-4">Search for a Clio 182 Trophy by...?</p>

              <div className="btn-group btn-group-lg d-flex mb-3" role="group">
                <input
                  type="radio"
                  className="btn-check"
                  name="opts"
                  id="option1"
                  data-searchtype={REQOP_BY_NUM}
                  autoComplete="off"
                  onClick={onClickSearchType}
                  defaultChecked
                />
                <label className="btn btn-secondary w-100" htmlFor="option1">
                  Number
                </label>
                <input
                  type="radio"
                  className="btn-check"
                  name="opts"
                  id="option2"
                  data-searchtype={REQOP_BY_VRM}
                  autoComplete="off"
                  onClick={onClickSearchType}
                />
                <label className="btn btn-secondary w-100" htmlFor="option2">
                  Registration
                </label>
                <input
                  type="radio"
                  className="btn-check"
                  name="opts"
                  id="option3"
                  data-searchtype={REQOP_BY_VIN}
                  autoComplete="off"
                  onClick={onClickSearchType}
                />
                <label className="btn btn-secondary w-100" htmlFor="option3">
                  VIN
                </label>
              </div>

              <form className="row g-3" onSubmit={onSubmit}>
                <div className="col-12">
                  <div className="input-group">
                    <input
                      className="form-control form-control-lg"
                      type={textType}
                      name="textSearch"
                      placeholder={textPlaceholder}
                      value={textSearch}
                      onChange={onChangeSearch}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <input
                    type="submit"
                    value="Search Now"
                    className="btn btn-primary btn-lg w-100"
                  />
                </div>
                {/* <div className="col-md-6">
                  {trophysContext.trophy && (
                    <button
                      className="btn btn-primary btn-lg w-100"
                      onClick={onClearResults}
                    >
                      Clear Results
                    </button>
                  )}
                </div> */}
              </form>

              {/* <form> */}
              {/* <div className="mb-3">
                  <input
                    className="form-control form-control-lg"
                    type="search"
                    placeholder="I'm looking for..."
                    aria-label="Search"
                    disabled={isLoading}
                    minLength={3}
                    maxLength={30}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div> */}

              {/* Error messages */}
              {/* {error && (
                  <div className="alert alert-danger mb-3">{error}</div>
                )} */}

              {/* Submit button */}
              {/* <button
                  className="btn btn-lg btn-primary w-100 w-sm-auto"
                  type="submit"
                  disabled={isLoading}
                  onClick={onClickSearchHandler}
                >
                  <span className="me-2">
                    <i className="bi bi-search"></i>
                  </span>
                  {isLoading ? 'Searching...' : 'Search'}
                </button> */}
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>

      {/* New */}

      {/* <div className="mb-2">I want to search by...</div> */}

      {/* <div>
        <div className="btn-group-vertical d-flex mb-3" role="group">
          <input
            type="radio"
            className="btn-check"
            name="opts"
            id="option1"
            data-searchtype={REQOP_BY_NUM}
            autoComplete="off"
            onClick={onClickSearchType}
            defaultChecked
          />
          <label className="btn btn-outline-primary w-100" htmlFor="option1">
            Number
          </label>
          <input
            type="radio"
            className="btn-check"
            name="opts"
            id="option2"
            data-searchtype={REQOP_BY_VRM}
            autoComplete="off"
            onClick={onClickSearchType}
          />
          <label className="btn btn-outline-primary w-100" htmlFor="option2">
            Registration
          </label>
          <input
            type="radio"
            className="btn-check"
            name="opts"
            id="option3"
            data-searchtype={REQOP_BY_VIN}
            autoComplete="off"
            onClick={onClickSearchType}
          />
          <label className="btn btn-outline-primary w-100" htmlFor="option3">
            VIN
          </label>
        </div>

        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-md-4">
            <div className="input-group">
              <input
                className="form-control form-control-lg"
                type={textType}
                name="textSearch"
                placeholder={textPlaceholder}
                value={textSearch}
                onChange={onChangeSearch}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-md-4">
            <input
              type="submit"
              value="Search Now"
              className="btn btn-secondary btn-lg w-100"
            />
          </div>
          <div className="col-md-4">
            {trophysContext.trophy && (
              <button
                className="btn btn-primary btn-lg w-100"
                onClick={onClearResults}
              >
                Clear Results
              </button>
            )}
          </div>
        </form>
      </div> */}
    </div>
  );
};

export default SearchTrophy;
